import "./css/form.css";
import { useForm, Controller } from "react-hook-form";
import React, { useState, useEffect, useRef } from "react";
import errorIcon from "./img/icon/errorIcon.png";
import SubHeader from "../components/subHeader4";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

function formatPhoneNumber(value) {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, "");

  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 8) {
    return `${phoneNumber.slice(0, 3)} - ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `${phoneNumber.slice(0, 3)} - ${phoneNumber.slice(
    3,
    7
  )} - ${phoneNumber.slice(7, 11)}`;
}

const As = () => {
  const [inputValue, setInputValue] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ shouldUseNativeValidation: true });
  const [checked, setChecked] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const MAX_LENGTH = 3;
  const handleInput = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setInputValue(formattedPhoneNumber);
  };

  const fileChangedHandler = (event) => {
    let file_size = event.target.files[0].size;
    console.log(file_size);
    if (file_size>5000000){
      event.target.value = null;
      alert(`파일 사이즈 5MB까지 업로드 가능합니다.`);
      return false;
    }
  
  };
  const uploadMultipleFiles = (e) => {
    if (Array.from(e.target.files).length > MAX_LENGTH) {
      e.preventDefault();
      e.target.value = null;
      alert(`Cannot upload files more than ${MAX_LENGTH}`);
      return false;
    } 
    console.log(Array.from(e.target.files).size );
    if (Array.from(e.target.files).size > 5000000) {
      
      e.preventDefault();
      e.target.value = null;
      alert(`파일 사이즈 5MB까지 업로드 가능합니다.`);
      return false;
    }
  }
  function onChange(value) {
    console.log("Captcha value:", value);
  }
  const onSubmit = async (data) => {
    const token = captchaRef.current.getValue();
    captchaRef.current.reset();
    //captcha가 체크됐을 때만
    if (token !== "") {
      await axios
        .post("https://thegmmedical.com:5002/api/token", { token })
        .then((res) => {
          console.log(res);
          if (res.data.responseDesc === "Success") {
            document.as_form.submit();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <div className="wrapper">
      <SubHeader />
      <h1 className="headerText">A/S접수</h1>
      <div className="ContactForm">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="contactForm">
                <form
                  id="as-form"
                  name="as_form"
                  onSubmit={handleSubmit(onSubmit)}
                  action="https://thegmmedical.com:5002/api/asrequest"
                  method="post"
                  encType="multipart/form-data"
                  acceptCharset="UTF-8"
                  noValidate
                >
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        작성자<span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          type="text"
                          name="name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "이름을 입력해주세요.",
                            },
                            maxLength: {
                              value: 30,
                              message: "Please use 30 characters or less",
                            },
                          })}
                          className="form-control formInput"
                        ></input>

                        {errors.name && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.name.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        {" "}
                        이메일<span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          className="form-control formInput"
                          name="email"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "이메일을 입력해 주세요.",
                            },
                            maxLength: {
                              message: "Please use 30 characters or less",
                            },
                            pattern: {
                              value:
                                /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,
                              message: "이메일 형식이 올바르지 않습니다",
                            },
                          })}
                        ></input>
                        {errors.email && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.email.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row formRow">
                    <div className="col phone">
                      <label htmlFor="type" className="form_tit">
                        전화번호<span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          type="text"
                          name="tel"
                          value={inputValue}
                          {...register("tel", {
                            required: "전화번호를 입력해 주세요.",
                            onChange: (e) => {
                              handleInput(e);
                            },
                          })}
                          className="form-control formInput"
                        ></input>

                        {errors.tel && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.tel.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        제품명<span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          type="text"
                          name="subject"
                          {...register("subject", {
                            required: {
                              value: true,
                              message: "제품명을 입력해 주세요.",
                            },
                            maxLength: {
                              value: 75,
                              message: "Subject cannot exceed 75 characters",
                            },
                          })}
                          className="form-control formInput"
                        ></input>
                        {errors.subject && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.subject.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        답변방법<span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <select name="reply_type">
                          <option value="phone" defaultValue>
                            전화
                          </option>
                          <option value="email">이메일</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        {" "}
                        내용<span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <textarea
                          rows={10}
                          name="content"
                          {...register("content", {
                            required: {
                              value: true,
                              message: "내용을 입력해 주세요.",
                            },
                          })}
                          className="form-control formInput"
                        ></textarea>

                        {errors.content && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.content.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        첨부파일
                      </label>
                      <div className="col_wrap">
                        <input
                          type="file"
                          id="files"
                          name="files"
                          className="file"
                          accept="image/*"
                          onChange={fileChangedHandler}
                        />
                        <div>
                          <ul>
                            <li>※ jpg,jpeg,gif,png 형식만 지원</li>
                            <li>※ 파일 사이즈 5MB까지 업로드 가능합니다.</li>
                            <li>
                              ※ 파일 첨부 시 개인정보에 주의하시기 바랍니다.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="reCAPTCHA">
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={onChange}
                    />
                  </div>
                  <div className="contact_agree">
                    <p className="tit">
                      개인정보 수집 및 이용 동의{" "}
                      <span className="point_txt">*</span>
                    </p>
                    <div className="">
                      정보통신망법 규정에 따라 (주)GM 메디칼은 다음의 개인정보를
                      수집 및 이용합니다. 자세히 읽은 후 동의하여 주시기
                      바랍니다. <br />
                      <br />
                      1. 개인정보의 수집 항목
                      <br />
                      이용 목적, 항목, 방법 / 수집하는 개인정보의 항목
                      <br />
                      회사는 이용자에 대하여 ‘제품 문의’에 필요한 개인정보,
                      서비스 제공을 위한 개인정보 등 필수사항을 홈페이지를 통해
                      수집하고 있습니다.
                      <br />
                      ‘제품 문의’ 이용과정에서 이용자로부터 수집하는 개인정보는
                      아래와 같습니다.
                      <br />
                      - 성명(한글), 회사명: 제품 문의 이용시 본인 혹은
                      회사확인을 위한 정보
                      <br />
                      - 연락처, 이메일: 제품 문의와 관련하여 정보 제공, 기타
                      마케팅 정보 제공을 위한 정보
                      <br />
                      ‘유선 문의’ 이용과정에서 이용자와 회사의 통화내용이
                      녹음되며, 상호간의 목적 달성 후 3개월 이내에 녹음 사항은
                      파기됩니다. <p></p>
                      <p>
                        2. 개인정보의 수집 방법
                        <br />
                        회사는 다음과 같은 방법으로 개인정보를 수집합니다.
                        <br />
                        - 홈페이지를 통한 ‘제품 문의’
                        <br />
                        - 홈페이지, 서면, 유선전화 등을 통한 문의
                        <br />- 회사가 운영하는 온/오프라인 행사
                      </p>
                      <p>
                        3. 개인정보의 이용
                        <br />
                        회사는 회사 관련 제반 서비스(PC /모바일 웹 포함)의
                        서비스 개발, 제공 및 향상의 목적으로만 개인정보를
                        이용합니다.
                        <br />
                        - 제품 문의 의사의 확인을 위하여 개인정보를 이용합니다.
                        <br />
                        - 법령 및 회사와 서비스의 원활한 운영에 지장을 주는
                        행위에 대한 방지 및 제재, 개인정보도용 및 부정거래 방지,
                        약관 개정 등의 고지사항 전달, 분쟁조정을 위한 기록 보존,
                        민원처리 등 이용자 보호 및 서비스 운영을 위하여
                        개인정보를 이용합니다.
                        <br />- 이벤트 정보 및 참여기회 제공, 광고성 정보 제공
                        등 마케팅 및 프로모션 목적으로 개인정보를 이용합니다.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="agree_check">
                    <input
                      type="checkbox"
                      name="acceptance"
                      defaultChecked={checked}
                      onChange={() => setChecked(!checked)}
                      id="acceptance"
                      aria-invalid="false"
                      {...register("acceptance", {
                        required: {
                          value: true,
                          message: "동의가 필요합니다.",
                        },
                      })}
                    />
                    <label htmlFor="acceptance"></label>
                    {errors.acceptance && (
                      <div className="form_error_wrap" style={{position:"absolute", top:"25px"}}>
                        <p className="form_error">
                          <img src={errorIcon} alt="error_icon"></img>
                          {errors.acceptance.message}
                        </p>
                      </div>
                    )}
                    <span>동의합니다. (필수) </span>{" "}
                    <span className="point_txt">*</span>
                  </div>
                  <input
                    className="submit-btn"
                    type="submit"
                    value="문의하기"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default As;
